import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/homepage';

export default function CommunityFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <div className="mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20reading%20community%20illustration%2C%20warm%20cozy%20atmosphere%20with%20books%20and%20digital%20devices%2C%20soft%20pastel%20tones%2C%20Korean%20art%20style%2C%20clean%20minimalist%20composition%2C%20modern%20digital%20illustration%2C%20inviting%20and%20friendly%20mood%2C%20subtle%20grain%20texture&width=900&height=400&seq=faq-banner-01&orientation=landscape"
            alt="韩漫在线社区"
            title="韩漫在线社区"
            className="w-full h-48 md:h-56 object-cover rounded-2xl"
          />
        </div>

        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 mb-10">
          解答您关于韩漫在线的常见疑问
        </p>

        <div className="flex flex-col gap-3 text-left">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {item.question}
                </span>
                <i
                  className={`text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === idx ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多关于我们
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}